<template>
    <div class="px-4">
        <h4 class="text-center"> Mis Cajas</h4>
        <!-- <div class="text-right">
            <v-checkbox v-model="eliminados" :label="`${eliminados?'incluir eliminados':'viendo solo activos'}`"></v-checkbox>
            <v-btn tile outlined color="green" @click="openregistrar()"> <v-icon left>mdi-plus</v-icon> Registrar </v-btn>
            <v-btn tile outlined color="green" @click="opencontador()"> <v-icon left>mdi-plus</v-icon> contador </v-btn>
            <v-btn tile outlined color="green" @click="opennominaciones()"> <v-icon left>mdi-plus</v-icon> Nominaciones </v-btn>
        </div> -->
        <div class="row">
            <div class="col-xs-12 col-sm-4">
                <!-- <v-btn tile outlined color="green" @click="openregistrar()"> <v-icon left>mdi-plus</v-icon> Apertura </v-btn> -->
                <v-btn tile outlined color="grey" @click="cargarDatos()"> <v-icon center>mdi-refresh</v-icon> </v-btn>
                <!-- <v-btn tile outlined color="green" @click="openrefagregarv2()"> <v-icon left>mdi-plus</v-icon> caja  </v-btn> -->
            </div>
            <div class="col-xs-12 col-sm-4">
            </div>
            <!-- <div class="col-xs-12 col-sm-4 text-right">
                <v-btn tile outlined color="green" @click="opennominaciones()"> <v-icon left>mdi-plus</v-icon> Nominaciones </v-btn>
            </div> -->
        </div>
        <v-checkbox v-model="eliminados" :label="`${eliminados?'incluir eliminados':'viendo solo activos'}`"></v-checkbox>
        <v-data-table :loading="loading" :headers="headers" :items="desserts" :items-per-page="25" class="elevation-1">
            <template v-slot:[`item.estado`]="{ item }">
                <p :class="item.estado?'green--text':'red--text'"> {{ item.estado?'Activo':'Cerrado' }} </p>
            </template>
            <template v-slot:[`item.deleted_at`]="{ item }">
                <p class="red--text"> {{ item.deleted_at }} </p>
            </template>
            <template v-slot:[`item.deleted_by`]="{ item }">
                <p class="red--text"> {{ item.deleted_by }} </p>
            </template>
            <template v-slot:[`item.opt`]="{ item }">
                <div style="min-width: 150px;"> 
                    <v-btn tile small text color="red" :disabled="!item.estado" @click="opencierre(item)"> <v-icon>mdi-close</v-icon> </v-btn>
                    <v-btn tile small text color="orange" @click="obtenerDetalles(item.id)"> <v-icon>mdi-eye</v-icon> </v-btn>
                    <v-btn tile small :disabled="item.estado" text color="orange" @click="obtenerReporte(item.id)"> <v-icon>mdi-download</v-icon> </v-btn>
                    <!-- <v-btn tile small text color="green" @click="openDeta(item.id)"> <v-icon>mdi-file</v-icon> </v-btn> -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }"> 
                            <v-btn  v-bind="attrs" v-on="on" :disabled="item.estado" tile small text color="blue" @click="$router.push('/depositos?idcaja='+item.id)"> <v-icon>mdi-file</v-icon> </v-btn>
                        </template>
                        <span> Depositos </span>
                    </v-tooltip>
                    
                </div>
            </template>
        </v-data-table>

        <contador ref="refcontador" v-on:success="cargarDatos"/>
        <registrar ref="refagregar" v-on:success="cargarDatos"/>
        <cierre ref="refcierre" v-on:onclose="cargarDatos"/>
        <abierta ref="refabierta" v-on:success="cargarDatos"/>
        
        <registrarv2 ref="refagregarv2" v-on:success="cargarDatos"/>
    </div>
  </template>

<script>
import contador from './contador.vue';
import registrar from './registrar.vue';
import registrarv2 from './registrarv2.vue';
import cierre from './cierre.vue';
import abierta from './caja-abierta-view.vue';
import xaxios from '@/xaxios';

export default {
    components:{contador,registrar,cierre,abierta,registrarv2},
    data () {
        return {
            headers: [ 
                { text: '#', value: 'nro' },
                { text: 'Monto apertura', value: 'monto_apertura' }, 
                { text: 'fecha apertura', value: 'fecha_apertura' },
                { text: 'fecha cierre', value: 'fecha_cierre' },
                { text: 'monto cierre', value: 'monto_cierre' }, 
                { text: 'estado', value: 'estado' },
                { text: 'Usuario', value: 'created_by' }, 
                { text: '', value: 'opt' },
            ],
            desserts: [],
            eliminados: false,
            loading: false,
        }
    },
    watch:{
        eliminados: function(){
            this.cargarDatos();
        },
        '$store.state.CARGO': function(){
            this.cargarDatos();
        }
    },
    methods:{
        opennominaciones(){
            this.$router.push('/nominaciones')
        },
        openregistrar(item=null){
            this.$refs.refagregar.openmodal(item);
        },
        opencontador(item=null){
            this.$refs.refcontador.openmodal(item);
        },
        async opencierre(item){
            this.loading = true;
            const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/cajas/${item.id}?detalle=true&recibos=true`
            const res = await xaxios.get(url).then(x=>x).catch(x=>x); 
            if(res && res.data){
                window.console.log('>>> res',res);
                let cajita = res.data;
                this.$refs.refcierre.openmodal(cajita);
            }
            this.loading = false;
    
        },
        openabierta(item=null){
            this.$refs.refabierta.openmodal(item);
        },
        // openrefagregarv2(item=null){
        //     this.$refs.refagregarv2.openmodal(item);
        // },
        async cargarDatos(){
            let idrol = this.$store.state.CARGO.id;
            let idsede = this.$store.state.CARGO.sede.id;
            let iduser = this.$store.state.DATA_USER.id;
            if(idrol != 1 && idrol != 14 && idrol != 15 && idrol != 25 ){
                this.$root.$notify.show(`Rol no autorizado`, { color: 'red', x: 'right' });
                return;
            }
            // window.console.log('rol:',idrol,iduser,idsede);
            
            this.loading = true;
            this.desserts = [];
            
            let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/cajas?sedeID=${idsede}`; 
            const damarisid = 73951;
            if(this.eliminados) url += '&eliminados=true'; 
            if((idrol == 15 || idrol == 25) && iduser != damarisid ) url += `&userID=${iduser}`;
            
            const res = await xaxios.get(url).then(x=>x).catch(x=>x);
            if(res && res.data ) {
                res.data.data.map((x,i)=>{
                    x,
                    x.nro = i+1
                })
                let d = res.data.data.filter(x=>x.id != 2 && x.id != 27)
                this.desserts = d;
            }
            this.loading = false;
        },
        confirmacionDelete(item) {
            const vue = this;
            var opt = {
                verification: 'eliminar',
                verificationHelp: 'Escriba "[+:verification]" para eliminar esta nominacion.',
                okText: 'eliminar',
                cancelText: 'cancelar',
                backdropClose: false,
                animation: 'bounce',
                loader: true,
                type: 'hard',
            };
            var message = {
                title: 'Confirmar',
                body:
                    '<br> <b>NOTA:</b> Una ves realizada la accion no hay vuelta atras </br></br>',
            };
            this.$dialog
            .confirm(message, opt)
            .then(async function(dialog) { 
                const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/caja/${item.id}`;
                const res = await xaxios.delete(url).then(x=>x).catch(x=>x);
                window.console.log(res);
                dialog.close();
                vue.cargarDatos();
            }).catch(function() {});
        },
        async obtenerDetalles(cajaid){
            this.loading = true; 
            let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/cajas/${cajaid}?detalle=true&recibos=true`; 
            const res = await xaxios.get(url).then(x=>x).catch(x=>x);
            if(res && res.data ){
                window.console.log('res',res);
                this.openabierta(res.data);
            }
            this.loading = false;
        },
        async obtenerReporte(cajaid){
            this.loading = true; 
            let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/cajas/reporte/${cajaid}`; 
            const res = await xaxios.get(url).then(x=>x).catch(x=>x);
            if(res && res.data ){
                window.console.log('res',res);

                const imgUri = this.getdatauri(res.data.data);
                const link = document.createElement('a')
                document.body.appendChild(link)

                link.href = imgUri
                link.target = '_self' 
                link.fileName = `CierreCaja-${res.data.data.created_at}.${res.data.data.extencion}`;
                link.download = `CierreCaja-${res.data.data.created_at}.${res.data.data.extencion}`;
                link.click()
            }
            this.loading = false;
        },
        getdatauri(archivo){
            if(!archivo) return '';
            return `data:${archivo.mimetype};base64,${archivo.file64}`
        }, 
        openDeta(cajaid){
            this.$refs.refagregarv2.openmodal(cajaid);
        }
    },
    async mounted(){ 
        this.cargarDatos();
        
    }
}
</script>